<template>
    <div    class=" w-full flex justify-center ">
        <div    class="w-full 2xl:w-4/5 py-8 px-8 max-w-7xl">
            <!-- User Personal Information -->
            <div>
                <div class="md:grid md:grid-cols-4 md:gap-6">
                    <div class="lg:pl-8 md:col-span-1">
                        <div class="flex flex-col items-start px-0 lg:px-4 sm:px-0">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 py-0">User Information</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-600">
                                This has the user's name and the email that will be used to login.
                            </p>
                        </div>
                    </div>
                    <div class="mt-5 md:mt-0 md:col-span-3">
                        <div class="sm:overflow-hidden">
                            <user-edit-personal-information
                                :user="user"
                                :companyList="companyList"
                                v-model:save="savePersonalInformation"
                            ></user-edit-personal-information>
                        </div>
                    </div>

                    <div    v-if="canEditUser()"
                            class="col-start-2 col-span-3 lg:px-4">
                        <button-blue-primary    @click="saveAll"
                        >
                            <div    v-if="saving"
                                    class="flex items-center">
                                <span   :class="iconLoading"></span>
                                <span>Saving</span>
                            </div>
                            <div    v-else>
                                <span>Save</span>
                            </div>
                        </button-blue-primary>
                    </div>
                </div>
            </div>

            <div class="hidden sm:block">
                <div class="py-5">
                    <div class="border-t border-gray-200"></div>
                </div>
            </div>

            <!-- Company Access Table -->
            <div class="mt-10 sm:mt-0">
                <div class="flex flex-col">
                    <div class="lg:pl-8 ">
                        <div class="flex flex-col items-start px-0">
                            <h3 class="text-lg font-medium leading-6 text-gray-900 py-0">Companies</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-600">
                                Companies
                            </p>
                        </div>
                    </div>

                    <div    class="lg:pl-8">
                        <inline-tab-header
                            :headers="companyFilters"
                            name="Filter By"
                            :current="activeCompanyFilter"
                            @update:current="updateCompanyFilter"
                        ></inline-tab-header>
                    </div>

                    <div    class="mt-5 md:mt-0">
                        <div class="overflow-hidden">
                            <div class="py-5 bg-white sm:p-6">
                                <div>
                                    <ajax-table     v-model:loading="ajaxTable.loading"
                                                    v-model:search="ajaxTable.search"
                                                    v-model:sort-by="ajaxTable.sortBy"
                                                    v-model:sort-desc="ajaxTable.sortDesc"
                                                    v-model:page="ajaxTable.page"
                                                    v-model:items-per-page="ajaxTable.itemsPerPage"
                                                    v-model:page-info="ajaxTable.pageInfo"
                                                    :data="companies"
                                                    :headers="headers"
                                                    @loadData="getCompanies"
                                                    @rowSelected="selectCompany"
                                    >
                                        <template   #col-1="props">
                                            <div    class="mt-6 relative z-0 flex shadow-sm rounded-md shrink"
                                                    @click="toggleCompanyAccess(props.rowIndex)">
                                                <button     type="button"
                                                            class="-ml-px relative inline-flex items-center px-4 py-2 border rounded-l-md bg-white text-sm font-medium hover:bg-gray-50"
                                                            :class="[props.row.belongs ? 'border-blue-500 text-gray-700 z-10' : 'border-gray-300 text-gray-500']"
                                                >
                                                    Allow
                                                </button>
                                                <button     type="button"
                                                            class="-ml-px relative inline-flex border-4 items-center px-4 py-2 border rounded-r-md bg-white text-sm font-medium hover:bg-gray-50"
                                                            :class="[!props.row.belongs ? 'border-blue-500 text-gray-700 z-10' : 'border-gray-300 text-gray-500']"
                                                >
                                                    Deny
                                                </button>
                                            </div>
                                        </template>

                                      <template   #col-2="props">
                                        <div class="flex flex-col">
                                          <span>{{ props.row.name}}</span>
                                          <span v-if="isPartner"
                                            class="mt-2 max-w-max inline-flex items-center rounded-full bg-purple-100 px-2.5 py-0.5 text-xs font-medium text-purple-800">
                                            {{ features[props.row.id] }}
                                          </span>
                                        </div>
                                      </template>

                                        <template   #col-3="props">
                                            <span   v-if="props.row.belongs && props.row.permissionLevel !== null">
                                                {{ props.row.permissionLevel }}
                                            </span>

                                            <span   v-else>
                                                -
                                            </span>
                                        </template>

                                        <!-- Notifications Display -->
                                        <template   #col-4="props">
                                            <div    v-if="props.row.belongs && props.row.notifications !== null">
                                                <user-notifications-show    :notifications="props.row.notifications"
                                                ></user-notifications-show>
                                            </div>

                                            <div    v-else>
                                                -
                                            </div>
                                        </template>
                                    </ajax-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div    v-if="companies.length > 0"
                    class="mt-10 sm:mt-0">
                <div    v-if="canEditUser()"
                        class="col-start-2 col-span-3 lg:px-4">
                    <button-blue-primary    @click="saveAll"
                    >
                        <div    v-if="saving"
                                class="flex items-center">
                            <span   :class="iconLoading"></span>
                            <span>Saving Page</span>
                        </div>
                        <div    v-else>
                            <span>Save Page</span>
                        </div>
                    </button-blue-primary>
                </div>
            </div>
        </div>
        <slide-over-panel     v-model:show="editingCompanySettings"
                        width="max-w-7xl"
                        @click.stop="">
            <template   #title>
                {{ companies[editingCompanyRow]['name'] }}
            </template>

            <template   #content>
                <div    class="mb-20">
                    <user-edit-company-information  :user-id="user.id"
                                                    :company-info="companies[editingCompanyRow]"
                                                    :show-timed-user-permission="true"
                                                    :un-snooze-notification-enabled="unSnoozeNotificationEnabled"
                                                    v-model:save="saveEditingCompany"
                    ></user-edit-company-information>

                    <div    v-if="canEditUser()"
                            class="mt-8">
                        <button-blue-primary    @click="saveEditingCompanyInformation"
                        >
                            <div    v-if="saveEditingCompany"
                                    class="flex items-center">
                                <span   :class="iconLoading"></span>
                                <span>Saving Company Information</span>
                            </div>
                            <div    v-else>
                                <span>Save Company Information</span>
                            </div>
                        </button-blue-primary>
                    </div>
                </div>

            </template>
        </slide-over-panel>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";

import UserEditPersonalInformation from "@/components/Users/UserEditPersonalInformation";
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary";
import AjaxTable from "@/components/elements/AjaxTable";
import SlideOverPanel from "@/components/elements/SlideOverPanel";
import UserNotificationsShow from "@/components/Users/UserNotificationsShow";
import UserEditCompanyInformation from "@/components/Users/UserEditCompanyInformation";
import InlineTabHeader from "@/components/elements/InlineTabHeader";

const MAX_COMPANIES_PER_REQUEST = 25

export default {
    name: "UserMultiSiteEdit",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin],
    components: {
        UserEditCompanyInformation,
        UserNotificationsShow,
        SlideOverPanel, AjaxTable, ButtonBluePrimary, UserEditPersonalInformation,
        InlineTabHeader,
    },
    props: {
        user: Object,
        companyList: Object,
        features: Object,
        isPartner: Boolean,
        unSnoozeNotificationEnabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            // This component
            loading: false,
            requestNumber: 0,
            savePersonalInformation: false,

            // Company Saving
            shouldSaveCompany: {},
            saveCompany: {},
            savingCompanyAccess: 0,

            editingCompanySettings: false,
            editingCompanyRow: null,
            saveEditingCompany: false,

            // Company Table info
            companies: [],
            headers: [
                {
                    name: '',
                    key: 'belongs',
                    sortBy: 'belongs',
                    canClick: false,
                },
                {
                    name: 'Company',
                    key: 'name',
                    sortBy: 'name',
                },
                {
                    name: 'Permission Level',
                    key: 'permissionLevel',
                    sortBy: '',
                },
                {
                    name: 'Notifications Enabled',
                    key: 'notificationsEnabled',
                    sortBy: 'notificationsEnabled',
                },
            ],

            // Inline Tab Filter Headers
            activeCompanyFilter: 'all',
            companyFilters: [
                {
                    text: 'All',
                    event: 'all',
                },
                {
                    text: 'Active',
                    event: 'active',
                },
                {
                    text: 'Inactive',
                    event: 'inactive',
                },
            ],
        }
    },
    created() {
        Object.keys(this.companyList).forEach(companyId => {
            this.shouldSaveCompany[companyId] = false
            this.saveCompany[companyId] = false
        })
    },
    mounted() {
    },
    methods: {
        saveUserPersonalInformation() {
            if (!this.canEditUser()) {
                return
            }

            this.savePersonalInformation = true
        },
        saveCompanyAccess() {
            if (!this.canEditUser()) {
                return
            }

            let companiesPerRequest = Math.max(MAX_COMPANIES_PER_REQUEST, Math.round(this.companies.length / MAX_COMPANIES_PER_REQUEST))
            for (let start = 0; start < this.companies.length; start += companiesPerRequest) {
                let params = {}
                let end = start + Math.min(this.companies.length - start, companiesPerRequest)
                for (let index = start; index < end; index++) {
                    params[this.companies[index].id] = this.companies[index].belongs
                }
                axios.put(this.company.buildCompanyApiInternalRoute(`user-companies-information/${this.user.id}`), {
                        companyAccess: params,
                }).then(response => {

                }).catch(error => {

                })
            }
        },
        saveEditingCompanyInformation() {
            if (!this.canEditUser()) {
                return
            }

            this.saveEditingCompany = true
        },
        saveAll() {
            if (!this.canEditUser()) {
                return
            }

            this.saveUserPersonalInformation()

            // for each company to save
            this.saveCompanyAccess()
        },
        getCompanies() {
            this.ajaxTable.loading = true
            this.requestNumber++
            this.companies = []
            this.editingCompanyRow = null
            this.editingCompanySettings = false
            let params = JSON.parse(JSON.stringify(this.ajaxTable))
            params.requestNumber = this.requestNumber
            params.companiesFilter = this.activeCompanyFilter

            // this.ajaxTable.loading = false
            // return
            axios.get(this.company.buildCompanyApiInternalRoute(`user-companies-information/${this.user.id}`),
                {
                    params: params,
                }
            ).then(response => {
                let data = response.data
                if (data.meta.requestNumber !== `${this.requestNumber}`) {
                    return
                }

                this.ajaxUpdateTableData(data)
                this.companies = !_.isNil(data.data) ? data.data : []

            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        selectCompany(row) {
            this.editingCompanyRow = row
            this.editingCompanySettings = true
        },
        toggleCompanyAccess(rowIndex) {
            let newVal = !this.companies[rowIndex]['belongs']
            this.companies[rowIndex]['belongs'] = newVal

            if (newVal) {
                this.selectCompany(rowIndex)
            }
        },
        updateCompanyFilter(val) {
            this.activeCompanyFilter = val
            this.getCompanies()
        },
        canEditUser() {
            return this.permissions.can('update_users')
        },
    },
    computed: {
        saving() {
            return this.savePersonalInformation
                || this.saveEditingCompany
                || this.savingCompanyAccess > 0

        },
    },
    watch: {
        saveEditingCompany(val, old) {
            if (val === false && old === true) {
                this.editingCompanyRow = null
                this.editingCompanySettings = false
            }
        },
        editingCompanySettings(val, old) {
            if (val === false && old === true) {
                this.getCompanies()
            }
        },
    },
}
</script>

<style scoped>

</style>